import {
    FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR,
    FETCH_DEPARTMENT_DROPDOWN_DATA_START,
    FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS,
    FETCH_OFFICE_DROPDOWN_DATA_START,
    FETCH_OFFICE_DROPDOWN_DATA_SUCCESS,
    FETCH_OFFICE_DROPDOWN_DATA_ERROR,
    FETCH_USER_DROPDOWN_DATA_ERROR,
    FETCH_USER_DROPDOWN_DATA_START,
    FETCH_USER_DROPDOWN_DATA_SUCCESS,
    FETCH_LANGUAGES_DROPDOWN_DATA_ERROR,
    FETCH_LANGUAGES_DROPDOWN_DATA_START,
    FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS,
    FETCH_COUNTRIES_DROPDOWN_DATA_ERROR,
    FETCH_COUNTRIES_DROPDOWN_DATA_START,
    FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS,
    FETCH_CLIENT_DROPDOWN_DATA_ERROR,
    FETCH_CLIENT_DROPDOWN_DATA_START,
    FETCH_CLIENT_DROPDOWN_DATA_SUCCESS,
    FETCH_CURRENCIES_DROPDOWN_DATA_ERROR,
    FETCH_CURRENCIES_DROPDOWN_DATA_START,
    FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS,
} from "./types";
import Cookies from "universal-cookie";
import { getInitialAuthState } from "../utils/authSession";

const cookiesRead = new Cookies();
const { jwtToken, user } = getInitialAuthState(cookiesRead);

let envState = {
    departmentDropdownData: [],
    officeDropdownData: [],
    departmentLoading: false,
    officeLoading: false,
    departmentError: null,
    officeError: null,
    userLoading: false,
    userError: null,
    userDropdownData: [],
    languageDropdownData: [],
    languageLoading: false,
    languageError: null,
    countriesDropdownData: [],
    countriesLoading: false,
    countriesError: null,
    clientDropdownData: [],
    clientLoading: false,
    clientError: null,
    currenciesDropdownData: [],
    currenciesLoading: false,
    currenciesError: null,
    user: user,
    jwtToken: jwtToken,
};

export const initialState = envState;

const GlobalReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DEPARTMENT_DROPDOWN_DATA_START:
            return { ...state, departmentLoading: true, departmentError: null };
        case FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                departmentLoading: false,
                departmentDropdownData: action.payload,
            };
        case FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                departmentLoading: false,
                departmentError: action.payload,
            };

        case FETCH_OFFICE_DROPDOWN_DATA_START:
            return { ...state, officeLoading: true, officeError: null };
        case FETCH_OFFICE_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                officeDropdownData: action.payload,
            };
        case FETCH_OFFICE_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload,
            };

        case FETCH_USER_DROPDOWN_DATA_START:
            return { ...state, userLoading: true, userError: null };
        case FETCH_USER_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                userLoading: false,
                userDropdownData: action.payload,
            };
        case FETCH_USER_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                userLoading: false,
                userError: action.payload,
            };

        case FETCH_LANGUAGES_DROPDOWN_DATA_START:
            return { ...state, languageLoading: true, languageError: null };
        case FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                languageLoading: false,
                languageDropdownData: action.payload,
            };
        case FETCH_LANGUAGES_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                languageLoading: false,
                languageError: action.payload,
            };

        case FETCH_COUNTRIES_DROPDOWN_DATA_START:
            return { ...state, countriesLoading: true, countriesError: null };
        case FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                countriesLoading: false,
                countriesDropdownData: action.payload,
            };
        case FETCH_COUNTRIES_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                countriesLoading: false,
                countriesError: action.payload,
            };

        case FETCH_CLIENT_DROPDOWN_DATA_START:
            return { ...state, clientLoading: true, clientError: null };
        case FETCH_CLIENT_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                clientLoading: false,
                clientDropdownData: action.payload,
            };
        case FETCH_CLIENT_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                clientLoading: false,
                clientError: action.payload,
            };

        case FETCH_CURRENCIES_DROPDOWN_DATA_START:
            return { ...state, currenciesLoading: true, currenciesError: null };
        case FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                currenciesLoading: false,
                currenciesDropdownData: action.payload,
            };
        case FETCH_CURRENCIES_DROPDOWN_DATA_ERROR:
            return {
                ...state,
                currenciesLoading: false,
                currenciesError: action.payload,
            };

        default:
            return state;
    }
};

export default GlobalReducer;
